import Button from "../../Button";
import DatePicker from "react-datepicker";
import constants from "../../../constants";
import Tag from "../../CommonComponents/Tag";
import { Editor } from "@tinymce/tinymce-react";
import Radio from "../../CommonComponents/Radio";
import { Offcanvas, Form } from "react-bootstrap";
import IconButton from "@mui/material/IconButton";
import "react-datepicker/dist/react-datepicker.css";
import AlertContext from "../../../context/AlertContext";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loading from "../../Notification-Loading/Loading/Loading";
import InputDropdown from "../../CommonComponents/InputDropdown";
import Tooltip from "../../CommonComponents/Tooltip";
import React, { useCallback, useContext, useEffect, useState } from "react";
import useS3FileManagement from "../../../Hooks/useS3FileManagement";
import { getDataFromStorage, emailBody } from "../../../util";
import InputField from "../../CommonComponents/InputField";
import Textarea from "../../CommonComponents/Textarea";
import DragAndDropUpload from "../../CommonComponents/DragAndDropUpload.js";
import Drawer from "../../CommonComponents/Drawer";
const BatchForm = ({ showPopUp, setShowPopUp, setRefresh }) => {
  const Alert = useContext(AlertContext);
  const { getPreSignedUrl } = useS3FileManagement();

  const axios = useAxiosPrivate();

  const MAX_IMAGE_SIZE = 150000;
  const role = getDataFromStorage("role");
  const learnerId = getDataFromStorage("learnerid");

  const [userInput, setUserInput] = useState({
    status: "y",
    emailBody: emailBody,
    batchimage:
      "data:image/png;base64,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",
    batchType:
      parseInt(getDataFromStorage("accountType")) ===
      constants.ACCOUNT_USAGE_TYPE.CLIENT_EVAL
        ? constants.BATCH_TYPE.TESTING
        : constants.BATCH_TYPE.LEARNING,
  });

  const [startDate, setStartDate] = useState("");
  const [pathOptions, setPathOptions] = useState([]);

  const [selectedPath, setSelectedPath] = useState({
    id: "",
    value: "",
    label: "",
  });
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const fetchPaths = useCallback(async () => {
    try {
      Alert.setIsLoaded(true);

      let response = await axios.get(
        "node/admin/learningpath?archived=false&isSharedLps=true",
        {
          headers: {
            "Content-type": "application/json",
          },
        },
      );

      if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        if (response.data.data !== null) {
          let resData = response.data.data;
          let pathOptions = [];

          for (let i = 0; i < resData.length; i++) {
            let temp = {
              value: resData[i].id,
              label: resData[i].name,
            };

            pathOptions.push(temp);
          }

          setPathOptions(pathOptions);
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: "There is no learning path",
          });
        }
      } else {
        Alert.setShowNotify({
          show: true,
          title: "Error !",
          msg: "Something went wrong while fetching learning path list. Please try again later.",
        });
      }
    } catch (error) {
      console.error("error in get path list", error);

      if (error.message.includes("403")) {
        Alert.setShowNotify({
          show: true,
          isUnAuth: true,
          title: "Warning !",
          msg: "You have been logged-out due to inactivity. Login again.",
        });
      } else
        Alert.setShowNotify({
          show: true,
          title: "Error !",
          msg: "Something went wrong. Please try again later or contact gradious team.",
        });
    } finally {
      Alert.setIsLoaded(false);
    }
  }, [axios, Alert.setShowNotify]);

  useEffect(() => {
    fetchPaths();
  }, [fetchPaths]);

  useEffect(() => {
    Alert.setIsLoaded(true);
    axios
      .get("node/admin/tag/get", {
        headers: { "Content-type": "application/json" },
      })
      .then((res) => {
        let tag = res.data.map((tag) => {
          return {
            value: tag.id,
            label: tag.name,
          };
        });

        setTags(tag);
      })
      .catch((error) => {
        if (error.message.includes("403")) {
          Alert.setShowNotify({
            show: true,
            isUnAuth: true,
            title: "Warning !",
            msg: "You have been logged-out due to inactivity. Login again.",
          });
        } else
          Alert.setShowNotify({
            show: true,
            title: "Error !",
            msg: "Something went wrong. Please try again later or contact gradious team.",
          });
      })
      .finally(() => Alert.setIsLoaded(false));
  }, []);

  const handleClosePopup = (event) => {
    event.preventDefault();
    setShowPopUp(false);
    setUserInput({
      status: "y",
      emailBody: emailBody,
      batchimage:
        "data:image/png;base64,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",
    });
    setStartDate("");
    setThumbnailFile(null);
  };

  const handleInputChange = (event, field) => {
    if (field === "thumbnail") {
      const uploadedFile = event.target.files?.[0];

      if (!uploadedFile) return;

      let reader = new FileReader();

      reader.onloadend = () => {
        const preview = reader.result;
        let fileType = undefined;

        if (preview.includes("data:image/jpeg")) fileType = "image/jpeg";
        else if (preview.includes("data:image/jpg"))
          fileType = "image/jpg";
        else if (preview.includes("data:image/png"))
          fileType = "image/png";
        else {
          Alert.setShowNotify({
            show: true,
            title: "Warning !",
            msg: "Wrong file type - JPEG and PNG only.",
          });
          setThumbnailFile(null);
          event.target.value = "";
          return;
        }

        if (preview.length > MAX_IMAGE_SIZE) {
          Alert.setShowNotify({
            show: true,
            title: "Warning !",
            msg: "File size is too large.",
          });
          setThumbnailFile(null);
          event.target.value = "";
          return;
        }

        setThumbnailFile({
          name: uploadedFile.name,
          size: uploadedFile.size,
          type: uploadedFile.type || fileType,
          preview,
        });
        setUserInput((prevInput) => ({
          ...prevInput,
          batchimage: preview,
        }));
      };

      reader.readAsDataURL(uploadedFile);
    } else if (field === "startDate") {
      const value = new Date(event).toLocaleDateString("fr-FR");

      let splitArr = value.split("/");
      let formatedDate = splitArr[2] + "-" + splitArr[1] + "-" + splitArr[0];

      setUserInput({ ...userInput, [field]: formatedDate });
    } else if (field === "emailBody")
      setUserInput({ ...userInput, [field]: event });
    else {
      if (role === "trainer")
        setUserInput({
          ...userInput,
          trainerid: learnerId,
          [event.target.name]: event.target.value,
        });
      else
        setUserInput({
          ...userInput,
          [event.target.name]: event.target.value,
        });
    }
  };

  const onFileChange = (file) => {
    if (!file.size) return;
    let reader = new FileReader();

    reader.onload = (e) => {
      const extension = file.name.split(".").pop().toLowerCase();
      if (extension !== "csv") {
        Alert.setShowNotify({
          show: true,
          title: "Warning!",
          msg: "Only CSV files are allowed.",
        });

        setCsvFile(null);

        return;
      } else if (e.target.result.length > MAX_IMAGE_SIZE) {
        Alert.setShowNotify({
          show: true,
          title: "Warning !",
          msg: "CSV is loo large.",
        });
        document.getElementById("uploadUser").value = "";
      } else {
        setCsvFile(file);
      }
    };

    reader.readAsDataURL(file);
  };

  const downloadUserTemplate = async () => {
    let URL = "";

    if (process.env.REACT_APP_DEPLOYMENT === "LOCAL")
      URL = "../../../assets/files/TEMPLATE_USER.csv";
    else {
      let data = await getPreSignedUrl(
        "Templates/TEMPLATE_USER.csv",
        undefined,
        "csv",
        "GET",
      );
      URL = data.url;
    }

    window.location.href = URL;
  };

  const handleSelectPath = (value) => {
    let paths = structuredClone(pathOptions);
    let path = paths.find((path) => path.value === value);
    if (path) setSelectedPath({ ...path });
  };

  const onSelectType = (checked, type) => {
    const details = { ...userInput };

    if (checked) details.batchType = type;

    if (role === "trainer") details.trainerid = learnerId;

    setUserInput(details);
  };

  const handleCreateBatch = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setLoading(true);
    let found = 0;

    if (!userInput?.name) {
      Alert.setShowNotify({
        show: true,
        title: "Warning !",
        msg: "Please give the batch name.",
      });

      found = 1;
    } else if (!userInput?.description || userInput.description === "") {
      Alert.setShowNotify({
        show: true,
        title: "Warning !",
        msg: `Please give the description for ${userInput.name} batch`,
      });

      found = 1;
    } else if (!userInput?.startDate || userInput.startDate === "") {
      Alert.setShowNotify({
        show: true,
        title: "Warning !",
        msg: `Please give the start date for ${userInput.name} batch`,
      });

      found = 1;
    }

    try {
      if (found === 0) {
        Alert.setIsLoaded(true);

        const form = new FormData();

        let data = { ...userInput };

        if (selectedPath.value && selectedPath.value !== "") {
          data.learningpathid = selectedPath.value;
          data.learningpathname = selectedPath.label;
        }
        if (csvFile) {
          form.append("csv", csvFile);
        }

        form.append("from", "addnewbatch");
        // form.append("csv", csvfile.files[0]);
        form.append("batchdata", JSON.stringify(data));
        form.append("tags", JSON.stringify(data.tags || []));

        let response = await axios({
          data: form,
          method: "post",
          url: "node/admin/batch/userviacsv",
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: `Batch is created successfully`,
          });
          setRefresh(true);
          setShowPopUp(false);
          setThumbnailFile(null);
          setUserInput({
            status: "y",
            emailBody: emailBody,
            batchimage:
              "data:image/png;base64,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",
            batchType:
              parseInt(getDataFromStorage("accountType")) ===
              constants.ACCOUNT_USAGE_TYPE.CLIENT_EVAL
                ? constants.BATCH_TYPE.TESTING
                : constants.BATCH_TYPE.LEARNING,
          });
        } else if (
          response.data.resultCode ===
            constants.RESULT_STATUS.TECHNICAL_ERROR &&
          response.data.msg.includes("Duplicate entry")
        ) {
          Alert.setShowNotify({
            show: true,
            title: "Warning !",
            msg: `This batch name  already exist please give a different name`,
          });
        } else if (
          response.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR
        ) {
          Alert.setShowNotify({
            show: true,
            title: "Warning !",
            msg: response.data.msg,
          });
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Error !",
            msg: "Something went wrong. Please try again later or contact gradious team.",
          });
        }

        if (response.data.hasOwnProperty("filedata")) {
          const url = window.URL.createObjectURL(
            new Blob([response.data.filedata]),
          );

          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", `${Date.now()}.csv`);
          document.body.appendChild(link);
          link.click();
        }
      }
    } catch (error) {
      console.error("error in create batch", error);

      if (error.message.includes("403")) {
        Alert.setShowNotify({
          show: true,
          isUnAuth: true,
          title: "Warning !",
          msg: "You have been logged-out due to inactivity. Login again.",
        });

        return;
      }
      if (error?.response?.data?.hasOwnProperty("filedata")) {
        const url = window.URL.createObjectURL(
          new Blob([error?.response?.data.filedata]),
        );
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", `${Date.now()}.csv`);
        document.body.appendChild(link);
        link.click();
      }
      Alert.setShowNotify({
        show: true,
        title: "Warning !",
        msg:
          error?.response?.data?.msg ||
          "Unable to add the users and create the batch. Please try again later.",
      });
    } finally {
      Alert.setIsLoaded(false);
      setLoading(false);
    }
  };

  return (
    <Drawer
      open={showPopUp}
      onClose={handleClosePopup}
      anchor="right"
      title="New Batch"
      width={500}
    >
      <div
        id="adminBatchDetailsForm"
        style={{
          marginRight: "-20px",
          paddingRight: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          padding: "0 10px 0 5px",
        }}
      >
        <div>
          <InputField
            label="Name"
            name="name"
            type="text"
            placeholder="Enter batch name"
            value={userInput.name || ""}
            onChange={handleInputChange}
            maxLength={100}
          />
        </div>
        <div>
          <Textarea
            label="Description"
            name="description"
            value={userInput.description || ""}
            onChange={handleInputChange}
            placeholder="Type description here"
            maxLength={200}
            rows={4}
          />
        </div>
        {parseInt(getDataFromStorage("accountType")) ===
          constants.ACCOUNT_USAGE_TYPE.LMS && (
          <div className="batch-type-cluster">
            <div id="batch-type">Type</div>
            <div className="batchTypeSec" id="batch-type-align">
              <Radio
                size="sm"
                text="Live Class"
                checked={userInput.batchType === constants.BATCH_TYPE.LEARNING}
                onChange={(checked) => {
                  onSelectType(checked, constants.BATCH_TYPE.LEARNING);
                }}
              />
              <Radio
                size="sm"
                text="Assessment"
                checked={userInput.batchType === constants.BATCH_TYPE.TESTING}
                onChange={(checked) => {
                  onSelectType(checked, constants.BATCH_TYPE.TESTING);
                }}
              />
              <Radio
                size="sm"
                text="Self-Paced"
                checked={userInput.batchType === constants.BATCH_TYPE.SELF}
                onChange={(checked) => {
                  onSelectType(checked, constants.BATCH_TYPE.SELF);
                }}
              />
            </div>
          </div>
        )}
        <div className="batch-type">
          {/* <Tag /> */}
          <InputDropdown
            label="Tags"
            placeholder="Select the tags"
            options={tags}
            creatable
            multiple
            value={userInput.tags ?? []}
            name="tags"
            onChange={(value) => setUserInput({ ...userInput, tags: value })}
          />
        </div>
        <div>
          <InputField
            label="Slack Id"
            name="slackId"
            type="text"
            placeholder="Enter slack id for batch"
            value={userInput.slackId || ""}
            onChange={handleInputChange}
          />
        </div>
        <div className="batch-type-cluster">
          <div id="batch-type">Start Date</div>
          <div className="date-picker">
            <DatePicker
              name="startDate"
              value={startDate}
              autoComplete="off"
              minDate={new Date()}
              dateFormat="dd/mm/yyyy"
              className="batchStartDate"
              id="date-picker-feild"
              placeholderText="Pick the date"
              onChange={(date) => {
                const d = new Date(date).toLocaleDateString("fr-FR");
                setStartDate(d);
                handleInputChange(date, "startDate");
              }}
            />
          </div>
        </div>

          <div className="batch-type-cluster">

            <DragAndDropUpload
              label="Upload Thumbnail"
              supportFormat={".jpeg, .jpg, .png"}
              text="Drag & Drop your thumbnail"
              file={thumbnailFile}
              onUpload={(event) => handleInputChange(event, "thumbnail")}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => e.preventDefault()}
              onRemoveFile={() => {
                setThumbnailFile(null);
                setUserInput((prev) => ({ ...prev, batchimage: "" }));
              }}
              hintText="(max size:150kb & supported format jpeg & png)"
            />
          </div>
          <div className="batch-type-cluster">
            <div id="batch-type">
              Path 
            </div>
            <div >
              <InputDropdown
                name="pathId"
                searchable
                options={pathOptions}
                placeholder="Select Path"
                value={selectedPath.value}
                onChange={handleSelectPath}
              />
            </div>
          </div>
          <div className="batch-type-cluster">
            
            <div className="uploadHeader">
              <span className="uploadHeaderText">Add Users</span>
              <Tooltip title="Download Template" isIcon={true}>
                <span
                  className="uploadHeaderIcon"
                  style={{ cursor: 'pointer' }}  // Ensure pointer cursor
                  onClick={() => {
                    downloadUserTemplate();   // function you want to call
                  }}
                >
                  <svg width="30" height="30" viewBox="0 0 36 36" fill="none">
                    <path
                      d="M25.5 20.5V23.8333C25.5 24.2754 25.3244 24.6993 25.0118 25.0118C24.6993 25.3244 24.2754 25.5 23.8333 25.5H12.1667C11.7246 25.5 11.3007 25.3244 10.9882 25.0118C10.6756 24.6993 10.5 24.2754 10.5 23.8333V20.5M13.8333 16.3333L18 20.5M18 20.5L22.1667 16.3333M18 20.5V10.5"
                      stroke="#667085"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Tooltip>
            </div>

          <DragAndDropUpload
            supportFormat=".csv"
            text="Drag & Drop CSV file"
            file={csvFile}
            onUpload={(event) => {
              onFileChange(event.target.files[0]);
            }}
            onRemoveFile={() => setCsvFile(null)}
          />
        </div>
        <div className="batch-type-cluter">
          <div id="batch-type">Email</div>
          <Editor
            id="batchEmailBody"
            textareaName="emailBody"
            value={userInput.emailBody}
            tinymceScriptSrc="/tinymce/tinymce.min.js"
            onEditorChange={(event) => handleInputChange(event, "emailBody")}
            init={{
              height: 500,
              menubar: false,
              branding: false,
              statusbar: false,
              license_key: "gpl",
              elementpath: false,
              selector: "textarea",
              allow_html_in_named_anchor: true,
              plugins: [
                "code",
                "code",
                "help",
                "media",
                "table",
                "lists",
                "anchor",
                "advlist",
                "charmap",
                "preview",
                "wordcount",
                "autoresize",
                "fullscreen",
                "visualblocks",
                "searchreplace",
                "insertdatetime",
              ],
              toolbar:
                "undo redo | blocks | " +
                "bold italic underline forecolor  | alignleft aligncenter " +
                "alignright alignjustify | bullist numlist outdent indent | " +
                "removeformat | help |",
              content_style:
                "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            }}
          />
        </div>
      </div>

      <div className="adminAddBatchDetailsBtn">
        <Button
          size="sm"
          onClick={handleClosePopup}
          hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
        />
        <Button
          size="sm"
          onClick={handleCreateBatch}
          disable={loading}
          hierarchy={{ type: "primary", buttonText: "Save" }}
        />
      </div>

      {/* {Alert.isLoaded && <Loading />} */}
    </Drawer>
  );
};

export default BatchForm;
